import { Helmet } from 'react-helmet-async';

const LocalBusinessSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": ["LocalBusiness", "ProfessionalService"],
    "@id": "https://cititekpro.com/#localbusiness",
    "name": "CitiTekPro",
    "image": "https://cititekpro.com/og-image.png",
    "description": "Full-service digital agency in Minneapolis, MN specializing in custom software development, web development, mobile app development, SEO services, IT consulting, and business automation for businesses across Minnesota and the Twin Cities.",
    "url": "https://cititekpro.com",
    "email": "contact@cititekpro.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "2910 Pillsbury Ave, Suite 31",
      "addressLocality": "Minneapolis",
      "addressRegion": "MN",
      "postalCode": "55408",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "44.9497",
      "longitude": "-93.2847"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      }
    ],
    "priceRange": "$$",
    "areaServed": [
      { "@type": "City", "name": "Minneapolis" },
      { "@type": "City", "name": "Saint Paul" },
      { "@type": "City", "name": "Bloomington" },
      { "@type": "City", "name": "Brooklyn Park" },
      { "@type": "City", "name": "Brooklyn Center" },
      { "@type": "City", "name": "Plymouth" },
      { "@type": "City", "name": "Maple Grove" },
      { "@type": "City", "name": "Richfield" },
      { "@type": "City", "name": "Burnsville" },
      { "@type": "City", "name": "Eagan" },
      { "@type": "City", "name": "Roseville" },
      { "@type": "City", "name": "Columbia Heights" },
      { "@type": "City", "name": "Fridley" },
      { "@type": "City", "name": "Saint Cloud" },
      { "@type": "City", "name": "Rochester" },
      { "@type": "City", "name": "Edina" },
      { "@type": "City", "name": "Blaine" },
      {
        "@type": "Neighborhood",
        "name": "Karmel Mall",
        "containedInPlace": { "@type": "City", "name": "Minneapolis" }
      },
      {
        "@type": "Neighborhood",
        "name": "Cedar-Riverside",
        "containedInPlace": { "@type": "City", "name": "Minneapolis" }
      },
      { "@type": "Place", "name": "Lake Street Minneapolis" },
      { "@type": "AdministrativeArea", "name": "Hennepin County" },
      { "@type": "AdministrativeArea", "name": "Ramsey County" },
      { "@type": "AdministrativeArea", "name": "Dakota County" },
      { "@type": "AdministrativeArea", "name": "Anoka County" },
      { "@type": "State", "name": "Minnesota" }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Digital & IT Services",
      "itemListElement": [
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Custom Software Development" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Web Development & Design" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Mobile App Development" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "SEO Services" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "IT Consulting" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Business Automation" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "AI Software Development" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "SaaS Application Development" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Custom CRM Development" } },
        { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "MERN Stack Development" } }
      ]
    },
    "sameAs": [
      "https://www.facebook.com/cititekpro",
      "https://www.linkedin.com/company/cititekpro",
      "https://www.instagram.com/cititekpro"
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default LocalBusinessSchema;
